export const PRICE_INFO_TITLE_CURRENT_PRICE = 'Current price';
export const PRICE_INFO_TITLE_DEPRECIATION = 'Depreciation';
export const PRICE_INFO_TITLE_DOWNPAYMENT = 'Downpayment';
export const PRICE_INFO_TITLE_INSTALMENT = 'Instalment';
export const PRICE_INFO_TITLE_COE_QUOTA_PREMIUM = 'COE quota premium';
export const PRICE_INFO_TITLE_ROAD_TAX = 'Road tax';
export const PRICE_INFO_TITLE_OMV = 'OMV';
export const PRICE_INFO_TITLE_ARF = 'ARF';
export const PRICE_INFO_TITLE_VES = 'VES';
export const PRICE_INFO_TITLE_EEAI = 'EEAI';
export const PRICE_INFO_TITLE_TOTAL_BASIC_COST = 'Total basic cost';
export const PRICE_INFO_TITLE_PREMIUM = 'Premium';
export const PRICE_INFO_TITLE_PREVIOUS_RECORDED_PRICE = 'Previous recorded price'; // @suppress longLineCheck
export const PRICE_INFO_TITLE_HIGHEST_RECORDED_PRICE = 'Highest recorded price';
export const PRICE_INFO_TITLE_LOWEST_RECORDED_PRICE = 'Lowest recorded price';
export const PRICE_INFO_SPAN_CONTENT_ARF = ' (After VES & EEAI rebates)';
export const PRICE_INFO_SPAN_CONTENT_REBATE = ' (Rebate)';
export const PRICE_INFO_SPAN_CONTENT_SURCHARGE = ' (Surcharge)';
export const PRICE_INFO_SPAN_CONTENT_ROCORDED_PRICE = ' (Past 6 mths)';

export const PRICE_SIGN_ICON_WIDTH = 11;
export const PRICE_SIGN_ICON_HEIGHT = 18;
